module.exports = __webpack_public_path__ + "static/img/claim-policy-right-img.c74b6c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-policy-right-img.svg
// module id = B+ZW
// module chunks = 1